<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="vx-card p-4">
        <div class="vx-row">
          <div class="vx-col w-4/5">
            <address-lookup @selectAddress="selectAddress"/>
          </div>
          <div class="vx-col w-1/5">
            <vs-button
                @click="addAddress"
            >
              Add Address Manually
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <div
        v-for="(address, index) in addresses"
        :key="index"
        :class="address.IsPrimaryAddress ? 'vx-col w-full' : 'vx-col w-1/2'"
        class="row"
    >
      <address-card
          v-model="addresses[index]"
          :ref="`addressCard${index}`"
          :validation-index="index"
          :is-primary="address.IsPrimaryAddress"
          show-buttons="true"
          @remove="remove(index)"
          @makePrimary="makePrimary(index)"
      />
    </div>
  </div>
</template>

<script>

import AddressCard from "../../../components/address/AddressCard";
import ValidationMessage from '../../../components/validation/ValidationMessage'
import FormValidateMixin from "../../../../components/mixins/FormValidateMixin";
import AddressLookup from "../../../components/address/AddressLookup";

export default {
  components: {
    ValidationMessage,
    AddressCard,
    AddressLookup
  },
  mixins: [FormValidateMixin],
  props: {
    value: {
      type: Array,
      required: true
    },
  },
  data () {
    return {
      rawEmailOptions: [],
      user_data: [],
      addresses: [],
      forms: ['addressCards'],
      validated: false,
    }
  },
  watch: {
    addresses: {
      async handler(val) {
        const formsLocal = ['phones'];

        val.forEach((addressCard, index) => {
          formsLocal.push(`addressCard${index}`)
        });

        this.forms = formsLocal;
      },
      deep: true,
    },
  },
  computed: {
    emailTypeOptions() {
      return this.rawEmailOptions.map(({ id, Type }) => { return { label: Type, value: id }  });
    },
  },
  methods: {
    async validate() {
      this.validated = await this.validateForms(this.forms);
    },
    remove(index) {
      this.$delete(this.addresses, index);
      this.$delete(this.forms, index);
    },
    makePrimary(index) {
      this.addresses.forEach((address, key) => {
        address.IsPrimaryAddress = (index === key) ? 1 : 0;
      });

      // now to move it to the top
      this.addresses.splice(0, 0, this.addresses.splice(index, 1)[0]);
    },
    addAddress() {
      this.addresses.push({
        'AddressType_FK': '',
        'AddressLine1': '',
        'AddressLine2': '',
        'AddressLine3': '',
        'City': '',
        'Province': '',
        'Region': '',
        'PostCode': '',
        'Country': '',
        'IsPrimaryAddress': this.addresses.length ? 0 : 1,
      });
    },
    updateValue(index, key, value) {
      this.value[index][key] = value;

      this.$emit("input", this.value);
    },

    async getEmailTypes() {
      try {
        const { data } = await this.$api.userEmailAddress.getOptions();
        this.rawEmailOptions = data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve email type options. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
    selectAddress(address) {
      address.AddressType_FK = '';
      address.IsPrimaryAddress = this.addresses.length ? 0 : 1;
      address.phone_numbers = [];
      this.addresses.push(address);
    },
    async getRelatedData() {
      await this.getEmailTypes();
    },
  },
  created () {
    this.getRelatedData();

    this.addresses = this.value;
  }
}
</script>

<style scoped>

</style>
